import { NavLink } from 'react-router-dom';

import {
  IconChevronDown as ChevronDownSVG,
  IconChevronUp as ChevronUpSVG,
  IconDevResources as DevResourcesSVG,
} from '../../../core';
import { Menus, NavigationTab } from '../types';

import CompactTab from './CompactTab';

const DevResources = ({
  handleMenuCollapse,
  collapsedMenus,
  isMenuClosed,
  setIsMenuClosed,
}: Omit<NavigationTab, 'collapsedSubMenus'>) => {
  const link = '/dev-resources';

  if (isMenuClosed)
    return (
      <CompactTab
        menuOption={Menus.DEV_RESOURCES}
        icon={<DevResourcesSVG />}
        handleMenuCollapse={handleMenuCollapse}
        setIsMenuClosed={setIsMenuClosed}
        href={link}
      />
    );

  return (
    <li>
      <NavLink
        onClick={() => handleMenuCollapse(Menus.DEV_RESOURCES)}
        to={link}
        className={({ isActive }) => (isActive ? 'active' : '')}
      >
        <>
          <div>
            <DevResourcesSVG />
            <span>Dev Resources</span>
          </div>
          {collapsedMenus.includes(Menus.DEV_RESOURCES) ? <ChevronDownSVG /> : <ChevronUpSVG />}
        </>
      </NavLink>
      <ul className={`lvl-2 ${collapsedMenus.includes(Menus.DEV_RESOURCES) ? 'collapsed' : ''}`}>
        <li>
          <NavLink
            to="/dev-resources/powerbikit"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Power BI Library</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dev-resources/excel-library"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Excel Library</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dev-resources/esrikit"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>ESRI Library</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dev-resources/figma-library"
            className={({ isActive }) => (isActive ? 'active' : '')}
          >
            <span>Figma Library</span>
          </NavLink>
        </li>
      </ul>
    </li>
  );
};

export default DevResources;
